import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const orig = err.config || {};
    const url = orig.url || "";
    if (err.response?.status === 401 && !orig._retry && !url.includes("/auth/")) {
      orig._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(orig);
      } catch {
        const p = window.location.pathname;
        if (p.startsWith("/portal") && !p.includes("login")) window.location.href = "/portal/login";
        else if (p.startsWith("/caregiver") && !p.includes("login")) window.location.href = "/caregiver/login";
        else if (p.startsWith("/patient") && !p.includes("login")) window.location.href = "/patient/login";
      }
    }
    return Promise.reject(err);
  }
);

export function fmtErr(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return fallback;
}
